/**
 * API configuration
 * This file contains the base URLs for API endpoints
 */

// API Base URL - Use HTTPS by default in production
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://api.elmo-burns.com/api' 
  : 'https://api.elmo-burns.com/api';

// Export the base URL for use across the application
export { API_BASE_URL };
